import { agendaConst } from '../../constants';

const formatTime = (time) => {
  if (!time) return time;
  return time.split(':').length === 2 ? `${time}:00` : time;
};

const applyAppointmentFallback = (data, appointmentById) => {
  // Las citas de tratamientos adquiridos no deben recibir fallback de treatmentId/treatmentsIds.
  if (data.appointmentOption === agendaConst.purchasedProducts) {
    return data;
  }

  if (!data.treatmentId && appointmentById) {
    return {
      ...data,
      treatmentId: appointmentById?.treatment?.id,
      treatmentsIds: appointmentById?.treatment?.id
        ? [appointmentById?.treatment?.id]
        : undefined,
      appointmentOption:
        data?.appointmentOption || appointmentById?.appointmentOption,
      treatmentTypeId:
        data?.treatmentTypeId || appointmentById?.treatment?.treatmentType?.id,
    };
  }

  return data;
};

export const buildAppointmentPayload = ({
  values,
  id,
  option,
  date,
  startTime,
  term,
  appointmentById,
  customerConfirmedEdit,
  cabains,
}) => {
  const { treatmentCategory, ...data } = values;

  const categoriesIds = treatmentCategory
    ?.map((row) => row?.categoryId)
    ?.filter(Boolean);

  let treatmentsIds;

  // En edición también puede cambiarse a "nuevos tratamientos", por eso se respetan todos los seleccionados.
  if (option === agendaConst.newTreatments) {
    treatmentsIds = treatmentCategory
      ?.map((row) => row?.treatmentId)
      ?.filter(Boolean);
  } else if (values?.treatmentId) {
    treatmentsIds = [values.treatmentId];
  } else if (appointmentById?.treatment?.id) {
    treatmentsIds = [appointmentById.treatment.id];
  }

  const treatmentId =
    treatmentCategory?.length > 0
      ? treatmentCategory[0]?.treatmentId
      : values?.treatmentId || appointmentById?.treatment?.id;

  const cabain = cabains?.find((cabain) => cabain?.id === values?.cabainId);

  const treatmentTypeId =
    cabain?.type?.treatmentType?.id ||
    values?.treatmentTypeId ||
    appointmentById?.treatment?.treatmentType?.id;

  const payload = {
    ...data,
    appointmentOption:
      values?.appointmentOption || option || appointmentById?.appointmentOption,
    date,
    startTime: formatTime(startTime),
    term: formatTime(term),
    categoriesIds,
    treatmentsIds,
    treatmentId,
    treatmentTypeId,
    customerConfirmedEdit,
    customerId: values.customerId ?? appointmentById?.customer?.id,
  };

  const payloadForOption = { ...payload };

  // Limpia campos que pertenecen a otras opciones para no mandar payloads mezclados al API.
  if (payloadForOption.appointmentOption !== agendaConst.purchasedProducts) {
    delete payloadForOption.purchasedProductId;
    delete payloadForOption.sessions;
  }

  if (payloadForOption.appointmentOption !== agendaConst.promotion) {
    delete payloadForOption.promoId;
  }

  if (payloadForOption.appointmentOption !== agendaConst.packages) {
    delete payloadForOption.packageId;
  }

  if (payloadForOption.appointmentOption === agendaConst.purchasedProducts) {
    // El tratamiento se deriva del purchasedProduct; no se manda treatmentId ni categoriesIds.
    delete payloadForOption.categoriesIds;
    delete payloadForOption.treatmentId;
    delete payloadForOption.treatmentsIds;
  }

  if (payloadForOption.appointmentOption === agendaConst.newTreatments) {
    delete payloadForOption.promoId;
    delete payloadForOption.packageId;
  }

  const payloadWithExistingPurchasedProduct =
    id &&
    payloadForOption.appointmentOption === agendaConst.purchasedProducts &&
    appointmentById?.purchasedProduct?.id
      ? {
          ...payloadForOption,
          // Si el usuario no re-selecciona el producto al editar, se conserva el de la cita original.
          purchasedProductId:
            payloadForOption.purchasedProductId ||
            appointmentById.purchasedProduct.id,
          sessions: payloadForOption.sessions ?? appointmentById.sessions,
        }
      : payloadForOption;

  return applyAppointmentFallback(
    payloadWithExistingPurchasedProduct,
    appointmentById
  );
};
